export const HEADER_MESSAGES = {
  // Validation
  ADDRESS_EMPTY: "Address cannot be empty",
  COMPLETE_REQUIRED_FIELDS: "Complete all required fields",
  DIGITS_ONLY: "Enter digits only",
  ID_PROOF_REQUIRED: "ID Proof is required",
  DECLARATION_REQUIRED: "Please accept the declaration",

  // Success
  ADDRESS_UPDATED: "Address updated successfully",
  ADDRESS_DELETED: "Address deleted successfully",
  INDIVIDUAL_UPDATED: "Individual updated successfully",

  // Fetch
  FETCH_SAVED_INDIVIDUALS_FAILED: "Failed to fetch saved individuals",
  FETCH_SAVED_ADDRESSES_FAILED: "Failed to fetch saved addresses",
  FETCH_NOTIFICATIONS_FAILED: "Failed to fetch notifications",

  // Update
  UPDATE_INDIVIDUAL_FAILED: "Failed to update individual",
  UPDATE_ADDRESS_FAILED: "Failed to update address",

  // Delete
  DELETE_SAVED_INFO_FAILED: "Failed to delete saved information",
  DELETE_ADDRESS_FAILED: "Failed to delete address",

  // Notification
  MARK_NOTIFICATIONS_READ_FAILED:
    "Failed to mark notifications as read",
};